import React from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import DocumentEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import { IHtmlEditorProps } from './types';
import { UploadAdapter } from './uploadAdapter/UploadAdapter';

// https://ckeditor.com/docs/ckeditor5/latest/api/module_core_editor_editorconfig-EditorConfig.html#member-typing
// https://ckeditor.com/docs/ckeditor5/latest/builds/guides/integration/frameworks/react.html#customizing-the-builds
// https://stackoverflow.com/questions/57320194/ckeditor-5-showing-video-element-but-plain-html-inserted-in-a-div-does-not-show
// https://ckeditor.com/docs/ckeditor5/latest/features/media-embed.html#configuration
export const HtmlEditor: React.FC<IHtmlEditorProps> = ({
  value,
  isInvalid,
  onChange,
}) => (
  <div className={isInvalid ? 'is-invalid' : ''}>
    <div id="toolbar-container" />
    <CKEditor
      editor={DocumentEditor}
      data={value}
      config={{ mediaEmbed: { previewsInData: true } }}
      onReady={(editor: any) => {
        const toolbarContainer: any =
          document.querySelector('#toolbar-container');
        toolbarContainer.appendChild(editor.ui.view.toolbar.element);

        editor.plugins.get('FileRepository').createUploadAdapter = (
          loader: any,
        ) => {
          return new UploadAdapter(loader);
        };
      }}
      onChange={(event: any, editor: any) => {
        const data = editor.getData();
        onChange(data);
      }}
    />
  </div>
);
